import React from "react"
import i18n from "@/i18n"
import { TextField } from "@/components/form"

const STYLES = {
  container: "bg-white rounded-lg p-6",
  header: "text-xl font-semibold mb-4 mt-0",
  fieldsContainer: "flex flex-col gap-4",
} as const

const CONTACT_FIELDS = [
  {
    name: "phone",
    labelKey: "app.settings.venues.tabbio.contact_information.phone",
    placeholder: "+1 (555) 123-4567",
    testId: "settings-venue-contact-input-phone",
  },
  {
    name: "email",
    labelKey: "app.settings.venues.tabbio.contact_information.email",
    type: "email" as const,
    testId: "settings-venue-contact-input-email",
  },
  {
    name: "website",
    labelKey: "app.settings.venues.tabbio.contact_information.website",
    placeholder: "https://...",
    testId: "settings-venue-contact-input-website",
  },
] as const

const ContactInformation: React.FC = () => {
  return (
    <div className={STYLES.container} data-testid="settings-venue-contact-container">
      <h2 className={STYLES.header}>{i18n.t("app.settings.venues.tabbio.contact_information.header")}</h2>
      <div className={STYLES.fieldsContainer}>
        {CONTACT_FIELDS.map(({ name, labelKey, testId, ...rest }) => (
          <TextField key={name} name={name} label={i18n.t(labelKey)} data-testid={testId} {...rest} />
        ))}
      </div>
    </div>
  )
}

export default ContactInformation
